import { Type } from '@angular/core';

export class DialogConfig<D = any> {
  data?: D;
  displayType?: Type<any>;
}
